import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Stack,
  Typography,
} from "@mui/material"
import { useTranslation } from "react-i18next"

import type { ParsedErrorType } from "@/api"

function Server({ error }: { error: Error | ParsedErrorType }) {
  const { t } = useTranslation()
  return (
    <Stack
      sx={{
        alignItems: "center",
        p: 5,
      }}
    >
      <Stack
        sx={{
          alignItems: "center",
          maxWidth: "600px",
        }}
      >
        <Box>
          <Typography variant="h3" paragraph>
            {t("500.title")}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ color: "text.secondary" }} gutterBottom>
            {t("500.description")}
            <br />
            <br />
            {t("IfThisErrorPersists")}
          </Typography>
        </Box>
        {!!error && (
          <Accordion
            sx={{
              "&.Mui-expanded": {
                boxShadow: "none",
              },
              marginTop: 4,
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>Details</AccordionSummary>
            <AccordionDetails>
              <Typography
                component="pre"
                sx={{
                  textAlign: "left",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-all",
                }}
              >
                {error.message}
              </Typography>
            </AccordionDetails>
          </Accordion>
        )}
        <Box
          component="img"
          sx={{
            height: 260,
            my: { xs: 5, sm: 6 },
          }}
          alt="500"
          src={"/assets/illustrations/server_down.svg"}
        />
        <Button
          size="large"
          variant="contained"
          onClick={() => (window.location.href = "/")}
          color="inherit"
        >
          {t("500.button")}
        </Button>
      </Stack>
    </Stack>
  )
}

export default Server
